import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M11 12L13 12M15 12H17M8 14.5L6 12L8 9.5" vectorEffect="non-scaling-stroke" />
	</SVG>
);
